export default __webpack_public_path__ + "static/media/Boys_Juggler.6636d2f5.svg";